import SlideshowGen3TechSpecsContent from './SlideShowOverlayFormatting/SlideshowGen3TechSpecsContent';
import SlideshowOR4TechSpecsContent from './SlideShowOverlayFormatting/SlideshowOR4TechSpecsContent';
import type { SlideshowItemContentProps } from './types';

const SlideshowItemContent = ({
  content,
  contentTitle,
  showDiscount,
  contentFormat,
}: SlideshowItemContentProps) => {
  switch (contentFormat) {
    case 'OR4TechSpec':
      return (
        <SlideshowOR4TechSpecsContent
          content={content}
          contentTitle={contentTitle}
          showDiscount={showDiscount}
        />
      );
    case 'OR3TechSpec':
      return (
        <SlideshowGen3TechSpecsContent
          content={content}
          showDiscount={showDiscount}
        />
      );
    default:
      return <></>;
  }
};

export default SlideshowItemContent;
